import { Box, Button, Typography } from "@mui/material";
import { MdArrowBack } from "react-icons/md";

import type { HomeScope } from "../types/home.types";
import { HOME_SCOPE_LABELS } from "../utils/homeFilters";
import { HOME_COLORS } from "./homeTheme";

interface HomeFilterBannerProps {
  /** Texto do filtro: card, status de fase, coordenador ou célula. */
  label: string;
  scope: HomeScope;
  onBack(): void;
  onClear(): void;
}

/** Faixa da lista de Projetos quando ela foi aberta pelo Início. */
export function HomeFilterBanner({
  label,
  scope,
  onBack,
  onClear,
}: HomeFilterBannerProps) {
  return (
    <Box display="flex" flexDirection="column" gap={1.5}>
      <Button
        onClick={onBack}
        startIcon={<MdArrowBack size={16} />}
        sx={{ alignSelf: "flex-start", textTransform: "none", px: 0 }}
      >
        Voltar
      </Button>
      <Box
        role="status"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        gap={1}
        sx={{
          px: 2,
          py: 1,
          borderRadius: "6px",
          bgcolor: HOME_COLORS.primaryLight,
          color: HOME_COLORS.primary,
        }}
      >
        <Typography sx={{ fontSize: 14 }}>
          Filtro vindo do Início: <b>{label}</b>, escopo{" "}
          {HOME_SCOPE_LABELS[scope]}
        </Typography>
        <Button size="small" onClick={onClear} sx={{ textTransform: "none" }}>
          Limpar filtro
        </Button>
      </Box>
    </Box>
  );
}
